import React from 'react';

export function AutomationTab({ formData, setFormData }) {
  return (
    <div className="space-y-6">
      {/* Email Reports */}
      <div className="p-5 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <span className="text-2xl">📬</span>
            <div>
              <h4 className="font-medium text-gray-800">Email-Berichte</h4>
              <p className="text-sm text-gray-500">Transkript per Email nach jedem Anruf</p>
            </div>
          </div>
          <button onClick={() => setFormData({ ...formData, report_config: { ...formData.report_config, enabled: !formData.report_config?.enabled } })} className={`relative w-14 h-7 rounded-full transition-colors ${formData.report_config?.enabled ? 'bg-blue-600' : 'bg-gray-300'}`}>
            <span className={`absolute top-1 left-1 w-5 h-5 bg-white rounded-full transition-transform ${formData.report_config?.enabled ? 'translate-x-7' : ''}`} />
          </button>
        </div>
        {formData.report_config?.enabled && (
          <div className="space-y-4 pt-4 border-t border-gray-200">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Empfänger</label>
              <input type="text" placeholder="berichte@firma.de; chef@firma.de" value={formData.report_config?.email || ''} onChange={(e) => setFormData({ ...formData, report_config: { ...formData.report_config, email: e.target.value } })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" data-testid="report-email-input" />
              <p className="text-xs text-gray-400 mt-1">Mehrere Adressen mit Semikolon (;) trennen</p>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {[
                { key: 'include_transcript', label: '📝 Transkript' },
                { key: 'include_caller_info', label: '📱 Anrufer-Info' },
                { key: 'include_tools_used', label: '🔧 Tools' },
                { key: 'include_summary', label: '📊 Zusammenfassung' }
              ].map((opt) => (
                <label key={opt.key} className="flex items-center gap-2 p-2 bg-white rounded border cursor-pointer hover:bg-gray-50">
                  <input type="checkbox" checked={formData.report_config?.[opt.key] !== false} onChange={(e) => setFormData({ ...formData, report_config: { ...formData.report_config, [opt.key]: e.target.checked } })} className="w-4 h-4 text-blue-600 rounded" />
                  <span className="text-sm">{opt.label}</span>
                </label>
              ))}
            </div>
            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
              <p className="text-xs text-green-700">Berichte werden automatisch nach jedem Gespräch an die angegebene Adresse gesendet — kein manuelles Setup nötig.</p>
            </div>
          </div>
        )}
      </div>

      {/* Webhook */}
      <div className="p-5 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <span className="text-2xl">🔗</span>
            <div>
              <h4 className="font-medium text-gray-800">Webhook (n8n)</h4>
              <p className="text-sm text-gray-500">Daten an externe Systeme senden</p>
            </div>
          </div>
          <button onClick={() => setFormData({ ...formData, webhook_config: { ...formData.webhook_config, enabled: !formData.webhook_config?.enabled } })} className={`relative w-14 h-7 rounded-full transition-colors ${formData.webhook_config?.enabled ? 'bg-blue-600' : 'bg-gray-300'}`}>
            <span className={`absolute top-1 left-1 w-5 h-5 bg-white rounded-full transition-transform ${formData.webhook_config?.enabled ? 'translate-x-7' : ''}`} />
          </button>
        </div>
        {formData.webhook_config?.enabled && (
          <div className="space-y-4 pt-4 border-t border-gray-200">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">URL</label>
              <input type="url" placeholder="https://n8n.example.com/webhook/..." value={formData.webhook_config?.url || ''} onChange={(e) => setFormData({ ...formData, webhook_config: { ...formData.webhook_config, url: e.target.value } })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Events</label>
              <div className="flex gap-2">
                {[
                  { id: 'call_started', label: '📞 Start' },
                  { id: 'call_ended', label: '📴 Ende' },
                  { id: 'tool_executed', label: '🔧 Tool' }
                ].map((event) => (
                  <button key={event.id} onClick={() => {
                    const events = formData.webhook_config?.events || [];
                    const newEvents = events.includes(event.id) ? events.filter(e => e !== event.id) : [...events, event.id];
                    setFormData({ ...formData, webhook_config: { ...formData.webhook_config, events: newEvents } });
                  }} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${(formData.webhook_config?.events || []).includes(event.id) ? 'bg-blue-600 text-white' : 'bg-white border text-gray-700 hover:bg-gray-50'}`}>
                    {event.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
